// Supabase initialization.
// Values come from environment variables (see .env.example).
// Supabase's free tier covers everything we need — Auth, Postgres database,
// and file Storage — with no credit card and a project you fully own.
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// True only once real values are present in .env.
export const isSupabaseConfigured = Boolean(url && anonKey);

// Storage bucket that holds uploaded report PDFs and images (public read).
export const MEDIA_BUCKET = "media";

// Until the site owner adds their keys, `supabase` is null and every data
// service / auth call guards on `isSupabaseConfigured`, so nothing runs.
export const supabase = isSupabaseConfigured ? createClient(url, anonKey) : null;

export default supabase;
